import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ACCESS_ROUTES } from '../config/accessRoutes';
import { generateAccessRouteLink } from '../utils/routeNotice';
import useRouteNoticePreference from '../hooks/useRouteNoticePreference';
import './SidebarAccessRoutes.css';

export default function SidebarAccessRoutes({ collapsed, isLoggedIn, userToken, onNavigate }) {
  const { t } = useTranslation();
  const mutedUntil = useRouteNoticePreference();

  return (
    <section className={`sidebar-access-routes${collapsed ? ' is-collapsed' : ''}`} aria-label={t('accessRoutes.title')}>
      {!collapsed && <p className="sidebar-group-label">{t('accessRoutes.title')}</p>}
      <ul>
        {ACCESS_ROUTES.map(route => {
          const domain = new URL(route.url).hostname;
          const routeName = t(`importantNotice.routes.${route.descriptionKey}`);
          const label = t('importantNotice.visitRoute', { route: routeName, domain });
          const title = `${domain} · ${routeName}${route.recommended ? ` · ${t('importantNotice.recommended')}` : ''}`;
          const href = generateAccessRouteLink(route.url, { isLoggedIn, userToken, mutedUntil });

          return (
            <li key={route.url}>
              <a href={href} referrerPolicy="no-referrer" onClick={onNavigate}
                className={route.recommended ? 'is-recommended' : undefined} aria-label={label} title={title}>
                {collapsed ? <span className="sidebar-route-short">{domain.split('.').pop()}</span> : (
                  <>
                    <span className="sidebar-route-info">
                      <strong>{domain}</strong>
                      <span>{routeName}{route.recommended && <em>{t('importantNotice.recommended')}</em>}</span>
                    </span>
                    <ArrowUpRight size={14} aria-hidden="true" />
                  </>
                )}
              </a>
            </li>
          );
        })}
      </ul>
      {!collapsed && <p className="sidebar-route-hint">{t('accessRoutes.hint')}</p>}
    </section>
  );
}
